import React from 'react';
import { connect } from 'react-redux';
import { mediaPickerActions } from '../../store';
import MediaPickerTabs from '../../common/MediaPickerTabs';
import MediaPickersConstants from '../../MediaPickersConstants';

const ImageElementPickerTabs = (props) => {
    const { imageElementPickerSelectedTab, setProperty, loadUserImageElementAssets, loadDefaultImageElementStockImages, imageElementAssetsCount, accountDetails } = props;

    const onSelectedTabChange = (event, value) => {
        if (imageElementPickerSelectedTab === value || value === null)
            return;

        if (value === MediaPickersConstants.MEDIA_PICKER_TABS.MY_ASSETS && !imageElementAssetsCount)
            loadUserImageElementAssets(1, MediaPickersConstants.USER_ASSETS_PER_PAGE);

        // The dialog opens on My Assets, so the stock gallery is only fetched once it is asked for.
        if (value === MediaPickersConstants.MEDIA_PICKER_TABS.IMAGES)
            loadDefaultImageElementStockImages();

        setProperty('imageElementPickerSelectedTab', value);
    };

    return (
        <MediaPickerTabs
            selectedTab={imageElementPickerSelectedTab}
            onTabChange={onSelectedTabChange}
            enabledTabs={MediaPickersConstants.IMAGE_ELEMENT_PICKER_ENABLED_TABS}
            userAuthenticated={Boolean(accountDetails.email)}
        />
    );
};

const mapStateToProps = (state) => {
    const { imageElementPickerSelectedTab, imagePickerSelectedTab, imageElementAssetsCount, imageAssetsCount } = state.mediaPicker;
    const { accountDetails } = state.app;

    return {
        imageElementPickerSelectedTab: imageElementPickerSelectedTab ?? imagePickerSelectedTab,
        imageElementAssetsCount: imageElementAssetsCount ?? imageAssetsCount,
        accountDetails
    };
};

const mapDispatchToProps = (dispatch) => {
    const setProperty = (key, value) => dispatch(mediaPickerActions.setProperty(key, value));
    const loadUserImageElementAssets = (pageNumber, itemsPerPage) => dispatch(mediaPickerActions.loadUserImageElementAssets(pageNumber, itemsPerPage));
    const loadDefaultImageElementStockImages = () => dispatch(mediaPickerActions.loadDefaultImageElementStockImages());

    return {
        setProperty,
        loadUserImageElementAssets,
        loadDefaultImageElementStockImages
    };
};

export default connect(mapStateToProps, mapDispatchToProps)(ImageElementPickerTabs);
